import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import showcaseApi from "../../lib/showcaseApi";

const NotesCtx = createContext(null);

export const useNotes = () => {
  const ctx = useContext(NotesCtx);
  return ctx || { counts: {}, notes: [], identityFor: () => null, noteCount: () => 0, addNote: async () => {}, deleteNote: async () => {}, refresh: async () => {} };
};

export const NotesProvider = ({ children }) => {
  const [counts, setCounts] = useState({});
  const [notes, setNotes] = useState([]);
  const [identities, setIdentities] = useState({});

  const refresh = useCallback(async () => {
    try {
      const r = await showcaseApi.notes();
      setCounts(r.counts || {});
      setNotes(r.notes || []);
      setIdentities(r.product_identities || {});
    } catch (e) {
      /* not signed in yet / transient — ignore */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const addNote = useCallback(
    async (payload) => {
      await showcaseApi.addNote(payload);
      await refresh();
    },
    [refresh]
  );

  const deleteNote = useCallback(
    async (id) => {
      await showcaseApi.deleteNote(id);
      await refresh();
    },
    [refresh]
  );

  const value = {
    counts,
    notes,
    refresh,
    addNote,
    deleteNote,
    noteCount: (key) => counts[key] || 0,
    identityFor: (slug) => identities[slug] || null,
  };

  return <NotesCtx.Provider value={value}>{children}</NotesCtx.Provider>;
};

export default NotesProvider;
